import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';
import { AddContractorSiteOwnerLinkModalComponent } from '../add-contractor-site-owner-link-modal/add-contractor-site-owner-link-modal.component';

@Component({
  selector: 'contractor-site-owner-links',
  templateUrl: './contractor-site-owner-links.component.html',
})
export class ContractorSiteOwnerLinksComponent implements OnInit {
  public contractorSiteOwnerLinks: any[];

  // pagination
  public pageSizes: any = environment.pageSizes;
  public pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  public defaultSortField = 'maintenance.name';
  private selectedSort = [this.defaultSortField + ',asc'];
  public isFilterLoading: boolean;
  private filterTextCompanyName: string = '';
  private filterTextSiteOwnerName: string = '';

  constructor(
    private contractorService: ContractorService,
    private notificationService: NotificationService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.resetPagination();
  }

  private getAllContractorSiteOwnerLinks() {
    const filters = [
      { key: 'contractor', value: this.filterTextCompanyName },
      { key: 'siteOwner', value: this.filterTextSiteOwnerName },
    ];

    this.contractorService.getAllContractorSiteOwnerLinks(this.pagination, this.selectedSort, filters).subscribe((data: any) => {
      this.contractorSiteOwnerLinks = data.body;
      this.pagination.totalRecords = data.totalRecords;
      this.isFilterLoading = false;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving worker list');
      this.isFilterLoading = false;
    });
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllContractorSiteOwnerLinks();
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();

    this.getAllContractorSiteOwnerLinks();
  }

  public onFilterTextChangedCompany(filterText: string) {
    this.isFilterLoading = true;
    this.filterTextCompanyName = filterText;

    this.goToFirstPage();
    this.getAllContractorSiteOwnerLinks();
  }

  public onFilterTextChangedSiteOwner(filterText: string) {
    this.isFilterLoading = true;
    this.filterTextSiteOwnerName = filterText;

    this.goToFirstPage();
    this.getAllContractorSiteOwnerLinks();
  }

  public customSort(sort: SortEvent) {
    let sortDirection: String = 'asc';

    if (sort.order === -1) {
      sortDirection = 'desc';
    }
    this.selectedSort = [];

    if (sort.field === 'contractor') {
      this.selectedSort.push('maintenance.name' + ',' + sortDirection);
      this.selectedSort.push('siteOwnerUser.skylarkUser.user.firstName,asc');
      this.selectedSort.push('siteOwnerUser.skylarkUser.user.lastName,asc');
    }

    if (sort.field === 'siteOwner') {
      this.selectedSort.push('siteOwnerUser.skylarkUser.user.firstName' + ',' + sortDirection);
      this.selectedSort.push('siteOwnerUser.skylarkUser.user.lastName' + ',' + sortDirection);
      this.selectedSort.push('maintenance.name,asc');
    }

    this.goToFirstPage();

    this.getAllContractorSiteOwnerLinks();
  }

  public openAddNewLinkModal() {
    const modalOptions: NgbModalOptions = { centered: true };
    const modal = this.modalService.open(AddContractorSiteOwnerLinkModalComponent, modalOptions);

    modal.result.then(result => {
      if (result === 'refresh') {
        this.resetPagination();
      }
    }).catch(() => { /* modal dismissed */ });
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
